'use client';

import { useTranslations } from 'next-intl';

import { alpha } from '@mui/material/styles';
import { Box, Stack, Button, Container, Typography } from '@mui/material';

import { paths } from 'src/routes/paths';

import { Iconify } from 'src/components/iconify';

export default function HomeAdvertise() {
  const t = useTranslations('Home.advertise');

  return (
    <Box
      component="section"
      sx={{
        position: 'relative',
        py: { xs: 10, md: 14 },
        bgcolor: 'grey.900',
        overflow: 'hidden',
      }}
    >
      {/* Glows */}
      <Box
        aria-hidden
        sx={{
          position: 'absolute',
          top: -120,
          right: -80,
          width: 600,
          height: 600,
          borderRadius: '50%',
          background: (theme) =>
            `radial-gradient(circle, ${alpha(theme.palette.primary.main, 0.25)} 0%, transparent 70%)`,
          pointerEvents: 'none',
        }}
      />
      <Box
        aria-hidden
        sx={{
          position: 'absolute',
          bottom: -100,
          left: -60,
          width: 400,
          height: 400,
          borderRadius: '50%',
          background: (theme) =>
            `radial-gradient(circle, ${alpha(theme.palette.secondary.main, 0.1)} 0%, transparent 70%)`,
          pointerEvents: 'none',
        }}
      />

      <Container sx={{ position: 'relative', zIndex: 2, px: { xs: 3, md: 4 } }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          alignItems={{ xs: 'stretch', md: 'center' }}
          justifyContent="space-between"
          spacing={{ xs: 4, md: 6 }}
          sx={{ textAlign: { xs: 'center', md: 'left' } }}
        >
          <Box sx={{ flex: 1, minWidth: 280 }}>
            <Typography
              sx={{
                fontSize: 11,
                fontWeight: 700,
                letterSpacing: 2,
                textTransform: 'uppercase',
                color: 'primary.light',
                mb: 2,
              }}
            >
              {t('overline')}
            </Typography>
            <Typography
              component="h2"
              sx={{
                fontFamily: 'Barlow, sans-serif',
                fontWeight: 800,
                fontSize: 'clamp(28px, 3.5vw, 44px)',
                lineHeight: 1.1,
                letterSpacing: '-1px',
                color: 'common.white',
                mb: 2.5,
              }}
            >
              {t('title')}
            </Typography>
            <Typography
              sx={{
                fontSize: 16,
                lineHeight: 1.65,
                color: alpha('#ffffff', 0.5),
                maxWidth: 420,
                mx: { xs: 'auto', md: 0 },
              }}
            >
              {t('description')}
            </Typography>
          </Box>

          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1.75}
            flexWrap="wrap"
            useFlexGap
            sx={{
              justifyContent: { xs: 'center', md: 'flex-end' },
              '& > a': { width: { xs: '100%', sm: 'auto' }, justifyContent: 'center' },
            }}
          >
            <Button
              href={paths.contact}
              variant="contained"
              color="secondary"
              size="large"
              endIcon={<Iconify icon="ic:round-arrow-right-alt" />}
              sx={{
                px: 4,
                py: 1.75,
                borderRadius: 1.25,
                fontSize: 15,
                fontWeight: 600,
                whiteSpace: 'nowrap',
                boxShadow: (theme) => `0 4px 24px ${alpha(theme.palette.secondary.main, 0.35)}`,
                '&:hover': {
                  boxShadow: (theme) => `0 8px 32px ${alpha(theme.palette.secondary.main, 0.45)}`,
                },
              }}
            >
              {t('contactUs')}
            </Button>
            <Button
              href={paths.auth.login}
              size="large"
              sx={{
                px: 3.5,
                py: 1.75,
                borderRadius: 1.25,
                fontSize: 15,
                fontWeight: 500,
                color: alpha('#ffffff', 0.72),
                bgcolor: alpha('#ffffff', 0.06),
                border: `1px solid ${alpha('#ffffff', 0.12)}`,
                '&:hover': { bgcolor: alpha('#ffffff', 0.1), color: '#fff' },
              }}
            >
              {t('login')}
            </Button>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
